const axios = require("axios");

const dicStore = {
  state: {
    locales: [],
    show_modal: false,
    modal_id: null,
    modal_title: null,
    eclipse_product_results: [],
  },
  mutations: {
    SET_LOCALES(state, locales) {
      // eslint-disable-next-line no-param-reassign
      state.locales = locales;
    },
    SET_MODAL_ID(state, id) {
      // eslint-disable-next-line no-param-reassign
      state.modal_id = id;
    },
    SET_MODAL_TITLE(state, title) {
      // eslint-disable-next-line no-param-reassign
      state.modal_title = title;
    },
    SET_MODAL_STATE(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.show_modal = status;
    },
  },
  actions: {
    setModal({ commit }, data) {
      commit("SET_MODAL_ID", data.modal_id);
      commit("SET_MODAL_TITLE", data.modal_title);
    },
    setModalState({ commit }, modalState) {
      commit("SET_MODAL_STATE", modalState);
    },
    async getLocales({ commit }) {
      try {
        const response = await axios.get("/locales");
        commit("SET_LOCALES", response.data.locales);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  },
};

export default dicStore;
